export class BaseAttribute {
    constructor(initObjectParams) {
        this.authorOrganizationId = null;
        if (initObjectParams && initObjectParams.hasOwnProperty('authorOrganizationId')) {
            this.authorOrganizationId = initObjectParams['authorOrganizationId'];
        }
        this.executorOrganizationId = null;
        if (initObjectParams && initObjectParams.hasOwnProperty('executorOrganizationId')) {
            this.executorOrganizationId = initObjectParams['executorOrganizationId'];
        }
        this.id = null;  // совпадает с id меропритятия
        if (initObjectParams && initObjectParams.hasOwnProperty('eventId')) {
            this.id = initObjectParams['eventId'];
        }
    }
}